export default [
    {
        path: '/presentation/placeholder',
        props: true,
        component: () => import('@/views/Proposal/Presentation/Placeholder/index'),
    },
];
